// import React from "react";

// const Calendar = ({
//   currentDate,
//   setCurrentDate,
//   availabilities,
//   selectedDates,
//   setSelectedDates,
//   isEditMode = false,
//   editingDates = [],
//   isBookEDPMode = false,
// }) => {
//   const monthNames = [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ];

//   const daysOfWeek = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

//   const getDaysInMonth = (date) => {
//     const year = date.getFullYear();
//     const month = date.getMonth();
//     const firstDay = new Date(year, month, 1);
//     const lastDay = new Date(year, month + 1, 0);
//     const daysInMonth = lastDay.getDate();
//     const startingDayOfWeek = firstDay.getDay();
//     const days = [];

//     const prevMonthLastDay = new Date(year, month, 0).getDate();
//     for (let i = startingDayOfWeek - 1; i >= 0; i--) {
//       days.push({
//         day: prevMonthLastDay - i,
//         isCurrentMonth: false,
//         date: new Date(year, month - 1, prevMonthLastDay - i),
//       });
//     }

//     for (let day = 1; day <= daysInMonth; day++) {
//       days.push({
//         day,
//         isCurrentMonth: true,
//         date: new Date(year, month, day),
//       });
//     }

//     const remainingDays = 42 - days.length;
//     for (let day = 1; day <= remainingDays; day++) {
//       days.push({
//         day,
//         isCurrentMonth: false,
//         date: new Date(year, month + 1, day),
//       });
//     }

//     return days;
//   };

//   const formatDateKey = (date) => {
//     return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
//       2,
//       "0"
//     )}-${String(date.getDate()).padStart(2, "0")}`;
//   };

//   const navigateMonth = (direction) => {
//     setCurrentDate((prev) => {
//       const newDate = new Date(prev);
//       newDate.setMonth(prev.getMonth() + direction);
//       return newDate;
//     });
//   };

//   const isToday = (date) => {
//     const today = new Date();
//     return date.toDateString() === today.toDateString();
//   };

//   const isPastDate = (date) => {
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);
//     const checkDate = new Date(date);
//     checkDate.setHours(0, 0, 0, 0);
//     return checkDate < today;
//   };

//   const isSunday = (date) => {
//     return date.getDay() === 0;
//   };

//   const getDateAvailability = (date) => {
//     const dateKey = formatDateKey(date);
//     return availabilities.find((item) => item.available_date === dateKey);
//   };

//   const isDateSelected = (date) => {
//     const dateKey = formatDateKey(date);
//     return selectedDates.includes(dateKey);
//   };

//   const isExistingAvailableDate = (date) => {
//     const dateKey = formatDateKey(date);
//     return editingDates.includes(dateKey);
//   };

//   const handleDateClick = (date, availability) => {
//     // Book EDP Mode: Manually select 3-6 consecutive available days
//     if (isBookEDPMode) {
//       if (isPastDate(date)) {
//         return;
//       }

//       if (!availability || availability.status_label !== "Available") {
//         alert(
//           "You can only select dates with 'Available' status for EDP booking."
//         );
//         return;
//       }

//       const dateKey = formatDateKey(date);
//       const isSelected = isDateSelected(date);

//       // If clicking an already selected date, remove it from selection
//       if (isSelected) {
//         setSelectedDates((prev) => prev.filter((d) => d !== dateKey));
//         return;
//       }

//       // Check if already selected 6 dates (maximum limit)
//       if (selectedDates.length >= 6) {
//         alert("You can only select a maximum of 6 dates for EDP booking.");
//         return;
//       }

//       // If this is the first date, add it
//       if (selectedDates.length === 0) {
//         setSelectedDates([dateKey]);
//         return;
//       }

//       // Check if the new date is consecutive to existing selections
//       const sortedDates = [...selectedDates].sort();
//       const allDates = [...sortedDates, dateKey].sort();

//       // Helper function to get next non-Sunday date
//       const getNextNonSundayDate = (fromDate) => {
//         let nextDate = new Date(fromDate);
//         nextDate.setDate(nextDate.getDate() + 1);
//         while (isSunday(nextDate)) {
//           nextDate.setDate(nextDate.getDate() + 1);
//         }
//         return nextDate;
//       };

//       // Helper function to get previous non-Sunday date
//       const getPrevNonSundayDate = (fromDate) => {
//         let prevDate = new Date(fromDate);
//         prevDate.setDate(prevDate.getDate() - 1);
//         while (isSunday(prevDate)) {
//           prevDate.setDate(prevDate.getDate() - 1);
//         }
//         return prevDate;
//       };

//       // Get the first and last dates from current selection
//       const firstDate = new Date(sortedDates[0]);
//       const lastDate = new Date(sortedDates[sortedDates.length - 1]);
//       const clickedDate = new Date(dateKey);

//       // Check if clicked date is consecutive (either before first or after last)
//       const nextAfterLast = getNextNonSundayDate(lastDate);
//       const prevBeforeFirst = getPrevNonSundayDate(firstDate);

//       const isNextToLast = formatDateKey(nextAfterLast) === dateKey;
//       const isPrevToFirst = formatDateKey(prevBeforeFirst) === dateKey;

//       if (!isNextToLast && !isPrevToFirst) {
//         alert(
//           "You can only select consecutive dates. Please select a date that is adjacent to your current selection (skipping Sundays)."
//         );
//         return;
//       }

//       // Verify all dates are consecutive (excluding Sundays)
//       let isConsecutive = true;
//       for (let i = 0; i < allDates.length - 1; i++) {
//         const currentDate = new Date(allDates[i]);
//         const expectedNext = getNextNonSundayDate(currentDate);
//         const actualNext = new Date(allDates[i + 1]);

//         if (formatDateKey(expectedNext) !== formatDateKey(actualNext)) {
//           isConsecutive = false;
//           break;
//         }
//       }

//       if (!isConsecutive) {
//         alert(
//           "You can only select consecutive dates. The selected dates must be in sequence (excluding Sundays)."
//         );
//         return;
//       }

//       // Add the date to selection
//       setSelectedDates((prev) => [...prev, dateKey].sort());
//       return;
//     }

//     // Original Edit/Create Mode logic
//     if (!isEditMode) {
//       alert(
//         "Please click 'Edit Availability' or 'Create Availability' button first."
//       );
//       return;
//     }

//     if (isPastDate(date)) {
//       return;
//     }

//     if (isSunday(date)) {
//       alert("Sundays cannot be selected as they are OFF days.");
//       return;
//     }

//     const dateKey = formatDateKey(date);
//     const isExisting = isExistingAvailableDate(date);
//     const isSelected = isDateSelected(date);

//     // EDIT MODE: Only allow toggling existing available dates
//     if (isEditMode === "edit") {
//       if (!isExisting) {
//         alert(
//           "In Edit Mode, you can only modify existing available dates. Use 'Create Availability' to add new dates."
//         );
//         return;
//       }

//       // Toggle selection for existing dates
//       if (isSelected) {
//         setSelectedDates((prev) => prev.filter((d) => d !== dateKey));
//       } else {
//         setSelectedDates((prev) => [...prev, dateKey]);
//       }
//       return;
//     }

//     // CREATE MODE: Only allow selecting new dates (not existing ones)
//     if (isEditMode === "create") {
//       // Check if date already has any availability status
//       if (availability) {
//         alert(
//           `This date is already marked as '${availability.status_label}'. You can only select new dates in Create Mode.`
//         );
//         return;
//       }

//       // Check if it's an existing available date
//       if (isExisting) {
//         alert(
//           "This date already exists in your availability. You can only select new dates in Create Mode."
//         );
//         return;
//       }

//       // Toggle selection for new dates only
//       if (isSelected) {
//         setSelectedDates((prev) => prev.filter((d) => d !== dateKey));
//       } else {
//         setSelectedDates((prev) => [...prev, dateKey]);
//       }
//       return;
//     }
//   };

//   // Generate dates for three consecutive months
//   const getThreeMonths = () => {
//     const months = [];
//     for (let i = 0; i < 3; i++) {
//       const monthDate = new Date(
//         currentDate.getFullYear(),
//         currentDate.getMonth() + i,
//         1
//       );
//       months.push({
//         date: monthDate,
//         days: getDaysInMonth(monthDate),
//       });
//     }
//     return months;
//   };

//   const threeMonths = getThreeMonths();

//   const renderMonth = (monthData, monthIndex) => {
//     const { date: monthDate, days } = monthData;

//     return (
//       <div
//         key={monthIndex}
//         className="flex-1 min-w-0 border-2 border-gray-300 rounded-lg p-2 bg-gray-50 shadow-sm"
//       >
//         <h3 className="text-sm font-semibold text-gray-800 mb-1.5 text-center">
//           {monthNames[monthDate.getMonth()]} {monthDate.getFullYear()}
//         </h3>

//         <div className="grid grid-cols-7 gap-0 mb-1">
//           {daysOfWeek.map((day) => (
//             <div
//               key={day}
//               className="text-center text-[10px] font-semibold text-gray-600 py-0.5"
//             >
//               {day}
//             </div>
//           ))}
//         </div>

//         <div className="grid grid-cols-7 gap-0">
//           {days.map((dayObj, index) => {
//             const availability = getDateAvailability(dayObj.date);
//             const selected = isDateSelected(dayObj.date);
//             const past = isPastDate(dayObj.date);
//             const today = isToday(dayObj.date);
//             const sunday = isSunday(dayObj.date);
//             const isExisting = isExistingAvailableDate(dayObj.date);

//             let cellClasses =
//               "relative h-9 rounded flex items-center justify-center transition-all ";
//             let textClasses = "text-[10px] font-medium ";

//             if (!dayObj.isCurrentMonth) {
//               cellClasses += "bg-gray-50 text-gray-300 ";
//             }

//             if (past && dayObj.isCurrentMonth) {
//               cellClasses += "bg-gray-100 cursor-not-allowed ";
//               textClasses += "text-gray-400 ";
//             } else if (sunday && dayObj.isCurrentMonth && !past) {
//               cellClasses +=
//                 "bg-orange-50 cursor-not-allowed border border-orange-200 ";
//               textClasses += "text-orange-600 ";
//             } else if (availability && dayObj.isCurrentMonth) {
//               if (availability.status_label === "Booked") {
//                 cellClasses += "bg-red-100 border-2 border-red-300 ";
//                 textClasses += "text-red-700 ";
//               } else if (availability.status_label === "Pending") {
//                 cellClasses += "bg-yellow-100 border-2 border-yellow-300 ";
//                 textClasses += "text-yellow-700 ";
//               } else {
//                 cellClasses += "bg-green-100 border-2 border-green-300 ";
//                 textClasses += "text-green-700 ";
//               }

//               // In edit mode, only existing available dates are clickable
//               if (
//                 isEditMode === "edit" &&
//                 availability.status_label === "Available"
//               ) {
//                 cellClasses += "cursor-pointer hover:bg-green-200 ";
//               }

//               // In create mode, existing dates are not clickable
//               if (isEditMode === "create") {
//                 cellClasses += "cursor-not-allowed opacity-60 ";
//               }

//               // In Book EDP mode, available dates are clickable
//               if (isBookEDPMode && availability.status_label === "Available") {
//                 cellClasses += "cursor-pointer hover:bg-green-200 ";
//               }

//               if (selected && (isEditMode || isBookEDPMode)) {
//                 cellClasses += "ring-2 ring-blue-400 ";
//               }

//               if (isEditMode === "edit" && isExisting && !selected) {
//                 cellClasses += "ring-2 ring-red-400 opacity-60 ";
//               }
//             } else if (selected && dayObj.isCurrentMonth) {
//               cellClasses +=
//                 "bg-blue-500 text-white cursor-pointer hover:bg-blue-600 ";
//               textClasses += "text-white ";
//             } else if (dayObj.isCurrentMonth && !past) {
//               if (isEditMode === "create") {
//                 // In create mode, only new dates (without availability) are clickable
//                 cellClasses +=
//                   "bg-white border border-gray-200 cursor-pointer hover:bg-gray-50 ";
//               } else if (isEditMode === "edit") {
//                 // In edit mode, new dates are not clickable
//                 cellClasses +=
//                   "bg-white border border-gray-200 cursor-not-allowed opacity-50 ";
//               } else if (isBookEDPMode) {
//                 // In Book EDP mode, only available dates are clickable
//                 cellClasses +=
//                   "bg-white border border-gray-200 cursor-not-allowed opacity-50 ";
//               } else {
//                 cellClasses += "bg-white border border-gray-200 ";
//               }
//               textClasses += "text-gray-700 ";
//             }

//             if (today && dayObj.isCurrentMonth) {
//               textClasses += "font-bold ";
//             }

//             return (
//               <div
//                 key={index}
//                 className={cellClasses}
//                 onClick={() =>
//                   !past &&
//                   !sunday &&
//                   dayObj.isCurrentMonth &&
//                   handleDateClick(dayObj.date, availability)
//                 }
//               >
//                 <div className={textClasses}>{dayObj.day}</div>

//                 {selected &&
//                   (isEditMode || isBookEDPMode) &&
//                   dayObj.isCurrentMonth && (
//                     <div className="absolute top-0.5 right-0.5 bg-blue-500 rounded-full p-0.5">
//                       <svg
//                         className="w-2 h-2 text-white"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={3}
//                           d="M5 13l4 4L19 7"
//                         />
//                       </svg>
//                     </div>
//                   )}

//                 {today && dayObj.isCurrentMonth && (
//                   <div className="absolute top-0.5 right-0.5 w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="bg-white rounded-lg shadow-md p-6">
//       {isBookEDPMode && (
//         <div className="mb-4 bg-purple-50 border border-purple-200 rounded-lg p-3">
//           <p className="text-sm text-purple-800">
//             <strong>Book EDP Mode:</strong> Select 3-6 consecutive available
//             dates by clicking on them one by one. Each new date must be next to
//             your previous selection. Sundays are automatically skipped. Click a
//             selected date to deselect it.
//           </p>
//         </div>
//       )}

//       {isEditMode === "edit" && (
//         <div className="mb-4 bg-purple-50 border border-purple-200 rounded-lg p-3">
//           <p className="text-sm text-purple-800">
//             <strong>Edit Mode:</strong> All existing available dates are checked
//             by default. Uncheck the dates you want to remove from your
//             availability. You cannot select new dates in this mode.
//           </p>
//         </div>
//       )}

//       {isEditMode === "create" && (
//         <div className="mb-4 bg-green-50 border border-green-200 rounded-lg p-3">
//           <p className="text-sm text-green-800">
//             <strong>Create Mode:</strong> Select only new dates to add to your
//             availability. You cannot select dates that already have any status
//             (Available, Booked, or Pending).
//           </p>
//         </div>
//       )}

//       <div className="flex items-center justify-between mb-6">
//         <button
//           onClick={() => navigateMonth(-1)}
//           className="p-2 hover:bg-gray-100 rounded-full transition-colors"
//           aria-label="Previous month"
//         >
//           <svg
//             className="w-6 h-6 text-gray-600"
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M15 19l-7-7 7-7"
//             />
//           </svg>
//         </button>

//         <h2 className="text-lg font-semibold text-gray-800">
//           {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()} -{" "}
//           {monthNames[(currentDate.getMonth() + 2) % 12]}{" "}
//           {currentDate.getMonth() + 2 > 11
//             ? currentDate.getFullYear() + 1
//             : currentDate.getFullYear()}
//         </h2>

//         <button
//           onClick={() => navigateMonth(1)}
//           className="p-2 hover:bg-gray-100 rounded-full transition-colors"
//           aria-label="Next month"
//         >
//           <svg
//             className="w-6 h-6 text-gray-600"
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M9 5l7 7-7 7"
//             />
//           </svg>
//         </button>
//       </div>

//       {/* Three months display */}
//       <div className="flex gap-4 mb-6">
//         {threeMonths.map((monthData, index) => renderMonth(monthData, index))}
//       </div>

//       <div className="mt-6 pt-4 border-t border-gray-200">
//         <div className="grid grid-cols-2 md:grid-cols-5 gap-2 text-xs">
//           <div className="flex items-center">
//             <div className="w-4 h-4 bg-green-100 border-2 border-green-300 rounded mr-2"></div>
//             <span>Available</span>
//           </div>
//           <div className="flex items-center">
//             <div className="w-4 h-4 bg-yellow-100 border-2 border-yellow-300 rounded mr-2"></div>
//             <span>Pending</span>
//           </div>
//           <div className="flex items-center">
//             <div className="w-4 h-4 bg-red-100 border-2 border-red-300 rounded mr-2"></div>
//             <span>Booked</span>
//           </div>
//           <div className="flex items-center">
//             <div className="w-4 h-4 bg-blue-500 rounded mr-2"></div>
//             <span>Selected</span>
//           </div>
//           <div className="flex items-center">
//             <div className="w-4 h-4 bg-orange-50 border border-orange-200 rounded mr-2"></div>
//             <span>Sunday (OFF)</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Calendar;

import React from "react";

const Calendar = ({
  currentDate,
  setCurrentDate,
  availabilities,
  selectedDates,
  setSelectedDates,
  isEditMode = false,
  editingDates = [],
  isBookEDPMode = false,
  loading = false, // Add loading prop
}) => {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const daysOfWeek = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();
    const days = [];

    const prevMonthLastDay = new Date(year, month, 0).getDate();
    for (let i = startingDayOfWeek - 1; i >= 0; i--) {
      days.push({
        day: prevMonthLastDay - i,
        isCurrentMonth: false,
        date: new Date(year, month - 1, prevMonthLastDay - i),
      });
    }

    for (let day = 1; day <= daysInMonth; day++) {
      days.push({
        day,
        isCurrentMonth: true,
        date: new Date(year, month, day),
      });
    }

    const remainingDays = 42 - days.length;
    for (let day = 1; day <= remainingDays; day++) {
      days.push({
        day,
        isCurrentMonth: false,
        date: new Date(year, month + 1, day),
      });
    }

    return days;
  };

  const formatDateKey = (date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0",
    )}-${String(date.getDate()).padStart(2, "0")}`;
  };

  const navigateMonth = (direction) => {
    setCurrentDate((prev) => {
      const newDate = new Date(prev);
      newDate.setMonth(prev.getMonth() + direction);
      return newDate;
    });
  };

  const isToday = (date) => {
    const today = new Date();
    return date.toDateString() === today.toDateString();
  };

  const isPastDate = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const checkDate = new Date(date);
    checkDate.setHours(0, 0, 0, 0);
    return checkDate < today;
  };

  const isSunday = (date) => {
    return date.getDay() === 0;
  };

  // Check if date is in the valid booking range (must be at least 30 days from today)
  const isInValidBookingRange = (date) => {
    if (!isBookEDPMode) return true;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const checkDate = new Date(date);
    checkDate.setHours(0, 0, 0, 0);

    // Minimum advance booking: 30 days from today
    const minBookingDate = new Date(today);
    minBookingDate.setDate(today.getDate() + 30);
    minBookingDate.setHours(0, 0, 0, 0);

    // Date must be at least 30 days in the future
    return checkDate >= minBookingDate;
  };

  const getDateAvailability = (date) => {
    const dateKey = formatDateKey(date);
    return availabilities.find((item) => item.available_date === dateKey);
  };

  const isDateSelected = (date) => {
    const dateKey = formatDateKey(date);
    return selectedDates.includes(dateKey);
  };

  const isExistingAvailableDate = (date) => {
    const dateKey = formatDateKey(date);
    return editingDates.includes(dateKey);
  };

  // Helper function to get next 6 consecutive non-Sunday "EDP Only" dates
  const getNext6ConsecutiveDates = (startDate, availabilities) => {
    const dates = [];
    let currentDate = new Date(startDate);
    let consecutiveCount = 0;
    const maxDaysToCheck = 60;
    let daysChecked = 0;

    while (consecutiveCount < 6 && daysChecked < maxDaysToCheck) {
      const dateKey = formatDateKey(currentDate);
      const availability = availabilities.find(
        (item) => item.available_date === dateKey,
      );

      // Check if current date is Sunday
      if (isSunday(currentDate)) {
        // Sunday breaks the consecutive chain, reset if we have any dates selected
        if (consecutiveCount > 0) {
          dates.length = 0;
          consecutiveCount = 0;
        }
        currentDate.setDate(currentDate.getDate() + 1);
        daysChecked++;
        continue;
      }

      // Check if the date is valid for booking
      if (!isInValidBookingRange(currentDate)) {
        currentDate.setDate(currentDate.getDate() + 1);
        daysChecked++;
        continue;
      }

      // Check if date is available and "EDP Only" status
      if (availability && availability.status_label === "EDP Only") {
        dates.push(dateKey);
        consecutiveCount++;
      } else {
        // Date is either not available or has different status
        if (consecutiveCount > 0) {
          dates.length = 0;
          consecutiveCount = 0;
        }
      }

      currentDate.setDate(currentDate.getDate() + 1);
      daysChecked++;
    }

    return consecutiveCount === 6 ? dates : [];
  };

  const handleDateClick = (date, availability) => {
    // Book EDP Mode: Automatically select 6 consecutive "EDP Only" days
    if (isBookEDPMode) {
      if (isPastDate(date)) {
        return;
      }

      if (!isInValidBookingRange(date)) {
        alert("You can only book dates that are at least 30 days from today.");
        return;
      }

      if (!availability || availability.status_label !== "EDP Only") {
        alert(
          "You can only select dates with 'EDP Only' status for EDP booking.",
        );
        return;
      }

      if (isSunday(date)) {
        alert("Sundays cannot be selected as they are OFF days.");
        return;
      }

      const dateKey = formatDateKey(date);

      // If clicking a date that's already part of selection, clear all
      if (selectedDates.includes(dateKey)) {
        setSelectedDates([]);
        return;
      }

      // Get next 6 consecutive "EDP Only" dates starting from clicked date
      const consecutive6Dates = getNext6ConsecutiveDates(date, availabilities);

      if (consecutive6Dates.length < 6) {
        alert(
          `Unable to find 6 consecutive 'EDP Only' dates starting from ${date.toLocaleDateString()}. ` +
            `Please select a different starting date. ` +
            `Note: Sundays and already booked dates break the consecutive chain.`,
        );
        return;
      }

      // Set all 6 dates as selected
      setSelectedDates(consecutive6Dates);
      return;
    }

    // Original Edit/Create Mode logic
    if (!isEditMode) {
      alert(
        "Please click 'Edit Availability' or 'Create Availability' button first.",
      );
      return;
    }

    if (isPastDate(date)) {
      return;
    }

    if (isSunday(date)) {
      alert("Sundays cannot be selected as they are OFF days.");
      return;
    }

    const dateKey = formatDateKey(date);
    const isExisting = isExistingAvailableDate(date);
    const isSelected = isDateSelected(date);

    // EDIT MODE: Only allow toggling existing available dates
    if (isEditMode === "edit") {
      if (!isExisting) {
        alert(
          "In Edit Mode, you can only modify existing available dates. Use 'Create Availability' to add new dates.",
        );
        return;
      }

      // Toggle selection for existing dates
      if (isSelected) {
        setSelectedDates((prev) => prev.filter((d) => d !== dateKey));
      } else {
        setSelectedDates((prev) => [...prev, dateKey]);
      }
      return;
    }

    // CREATE MODE: Only allow selecting new dates (not existing ones)
    if (isEditMode === "create") {
      // Check if date already has any availability status
      if (availability) {
        alert(
          `This date is already marked as '${availability.status_label}'. You can only select new dates in Create Mode.`,
        );
        return;
      }

      // Check if it's an existing available date
      if (isExisting) {
        alert(
          "This date already exists in your availability. You can only select new dates in Create Mode.",
        );
        return;
      }

      // Toggle selection for new dates only
      if (isSelected) {
        setSelectedDates((prev) => prev.filter((d) => d !== dateKey));
      } else {
        setSelectedDates((prev) => [...prev, dateKey]);
      }
      return;
    }
  };

  // Generate dates for three consecutive months
  const getThreeMonths = () => {
    const months = [];
    for (let i = 0; i < 3; i++) {
      const monthDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + i,
        1,
      );
      months.push({
        date: monthDate,
        days: getDaysInMonth(monthDate),
      });
    }
    return months;
  };

  const threeMonths = getThreeMonths();

  // Skeleton Loading Component for a single month
  const renderSkeletonMonth = (monthIndex) => {
    return (
      <div
        key={monthIndex}
        className="flex-1 min-w-0 border-2 border-gray-300 rounded-lg p-2 bg-gray-50 shadow-sm"
      >
        {/* Skeleton Month Title */}
        <div className="h-5 bg-gray-300 rounded animate-pulse mb-3 mx-auto w-32"></div>

        {/* Skeleton Days of Week */}
        <div className="grid grid-cols-7 gap-0 mb-1">
          {daysOfWeek.map((day, idx) => (
            <div
              key={idx}
              className="text-center text-[10px] font-semibold text-gray-400 py-0.5"
            >
              {day}
            </div>
          ))}
        </div>

        {/* Skeleton Calendar Grid */}
        <div className="grid grid-cols-7 gap-0">
          {Array.from({ length: 42 }).map((_, index) => (
            <div
              key={index}
              className="relative h-9 rounded flex items-center justify-center"
            >
              <div className="w-6 h-6 bg-gray-300 rounded animate-pulse"></div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderMonth = (monthData, monthIndex) => {
    const { date: monthDate, days } = monthData;

    return (
      <div
        key={monthIndex}
        className="flex-1 min-w-0 border-2 border-gray-300 rounded-lg p-2 bg-gray-50 shadow-sm"
      >
        <h3 className="text-sm font-semibold text-gray-800 mb-1.5 text-center">
          {monthNames[monthDate.getMonth()]} {monthDate.getFullYear()}
        </h3>

        <div className="grid grid-cols-7 gap-0 mb-1">
          {daysOfWeek.map((day) => (
            <div
              key={day}
              className="text-center text-[10px] font-semibold text-gray-600 py-0.5"
            >
              {day}
            </div>
          ))}
        </div>

        <div className="grid grid-cols-7 gap-0">
          {days.map((dayObj, index) => {
            const availability = getDateAvailability(dayObj.date);
            const selected = isDateSelected(dayObj.date);
            const past = isPastDate(dayObj.date);
            const today = isToday(dayObj.date);
            const sunday = isSunday(dayObj.date);
            const isExisting = isExistingAvailableDate(dayObj.date);
            const inValidRange = isInValidBookingRange(dayObj.date);

            let cellClasses =
              "relative h-9 rounded flex items-center justify-center transition-all ";
            let textClasses = "text-[10px] font-medium ";

            if (!dayObj.isCurrentMonth) {
              cellClasses += "bg-gray-50 text-gray-300 ";
            }

            if (past && dayObj.isCurrentMonth) {
              cellClasses += "bg-gray-100 cursor-not-allowed ";
              textClasses += "text-gray-400 ";
            } else if (sunday && dayObj.isCurrentMonth && !past) {
              cellClasses +=
                "bg-orange-50 cursor-not-allowed border border-orange-200 ";
              textClasses += "text-orange-600 ";
            } else if (availability && dayObj.isCurrentMonth) {
              if (availability.status_label === "Booked") {
                cellClasses += "bg-red-100 border-2 border-red-300 ";
                textClasses += "text-red-700 ";
              } else if (availability.status_label === "Pending") {
                cellClasses += "bg-yellow-100 border-2 border-yellow-300 ";
                textClasses += "text-yellow-700 ";
              } else if (availability.status_label === "EDP Only") {
                cellClasses += "bg-indigo-100 border-2 border-indigo-400 ";
                textClasses += "text-indigo-800 ";
              } else if (availability.status_label === "Available") {
                cellClasses += "bg-green-100 border-2 border-green-300 ";
                textClasses += "text-green-700 ";
              }

              if (
                isEditMode === "edit" &&
                availability.status_label === "Available"
              ) {
                cellClasses += "cursor-pointer hover:bg-green-200 ";
              }

              if (isEditMode === "create") {
                cellClasses += "cursor-not-allowed opacity-60 ";
              }

              if (
                isBookEDPMode &&
                availability.status_label === "EDP Only" &&
                inValidRange
              ) {
                cellClasses += "cursor-pointer hover:bg-indigo-200 ";
              } else if (
                isBookEDPMode &&
                availability.status_label === "EDP Only" &&
                !inValidRange
              ) {
                cellClasses += "cursor-not-allowed opacity-70 ";
              }

              if (selected && (isEditMode || isBookEDPMode)) {
                cellClasses += "ring-2 ring-blue-400 ";
              }

              if (isEditMode === "edit" && isExisting && !selected) {
                cellClasses += "ring-2 ring-red-400 opacity-60 ";
              }
            } else if (selected && dayObj.isCurrentMonth) {
              cellClasses +=
                "bg-blue-500 text-white cursor-pointer hover:bg-blue-600 ";
              textClasses += "text-white ";
            } else if (dayObj.isCurrentMonth && !past) {
              if (isEditMode === "create") {
                cellClasses +=
                  "bg-white border border-gray-200 cursor-pointer hover:bg-gray-50 ";
              } else if (isEditMode === "edit") {
                cellClasses +=
                  "bg-white border border-gray-200 cursor-not-allowed opacity-50 ";
              } else if (isBookEDPMode) {
                cellClasses +=
                  "bg-white border border-gray-200 cursor-not-allowed opacity-50 ";
              } else {
                cellClasses += "bg-white border border-gray-200 ";
              }
              textClasses += "text-gray-700 ";
            }

            if (today && dayObj.isCurrentMonth) {
              textClasses += "font-bold ";
            }

            return (
              <div
                key={index}
                className={cellClasses}
                // onClick={() =>
                //   !past &&
                //   !sunday &&
                //   dayObj.isCurrentMonth &&
                //   (isBookEDPMode
                //     ? inValidRange && handleDateClick(dayObj.date, availability)
                //     : handleDateClick(dayObj.date, availability))
                // }
              >
                <div className={textClasses}>{dayObj.day}</div>

                {selected &&
                  (isEditMode || isBookEDPMode) &&
                  dayObj.isCurrentMonth && (
                    <div className="absolute top-0.5 right-0.5 bg-blue-500 rounded-full p-0.5">
                      <svg
                        className="w-2 h-2 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={3}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                  )}

                {today && dayObj.isCurrentMonth && (
                  <div className="absolute top-0.5 right-0.5 w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      {isBookEDPMode && (
        <div className="mb-4 bg-purple-50 border border-purple-200 rounded-lg p-3">
          <p className="text-sm text-purple-800">
            <strong>Book EDP Mode:</strong> You can book dates marked as "EDP
            Only" that are at least 30 days from today, in any future month.
            Click on any "EDP Only" date to automatically select 6 consecutive
            "EDP Only" dates (excluding Sundays and already booked dates). If
            there is a Sunday or booked date in between, the selection will not
            continue beyond that point. Click any selected date to clear the
            selection.
          </p>
        </div>
      )}

      {isEditMode === "edit" && (
        <div className="mb-4 bg-purple-50 border border-purple-200 rounded-lg p-3">
          <p className="text-sm text-purple-800">
            <strong>Edit Mode:</strong> All existing available dates are checked
            by default. Uncheck the dates you want to remove from your
            availability. You cannot select new dates in this mode.
          </p>
        </div>
      )}

      {isEditMode === "create" && (
        <div className="mb-4 bg-green-50 border border-green-200 rounded-lg p-3">
          <p className="text-sm text-green-800">
            <strong>Create Mode:</strong> Select only new dates to add to your
            availability. You cannot select dates that already have any status
            (Available, Booked, or Pending).
          </p>
        </div>
      )}

      {/* Show skeleton while loading */}
      {loading ? (
        <>
          {/* Skeleton Navigation */}
          <div className="flex items-center justify-between mb-6">
            <div className="w-10 h-10 bg-gray-300 rounded-full animate-pulse"></div>
            <div className="h-6 bg-gray-300 rounded animate-pulse w-64"></div>
            <div className="w-10 h-10 bg-gray-300 rounded-full animate-pulse"></div>
          </div>

          {/* Skeleton Three Months */}
          <div className="flex gap-4 mb-6">
            {[0, 1, 2].map((index) => renderSkeletonMonth(index))}
          </div>

          {/* Skeleton Legend */}
          <div className="mt-6 pt-4 border-t border-gray-200">
            <div className="grid grid-cols-2 md:grid-cols-6 gap-2">
              {Array.from({ length: 6 }).map((_, idx) => (
                <div key={idx} className="flex items-center">
                  <div className="w-4 h-4 bg-gray-300 rounded mr-2 animate-pulse"></div>
                  <div className="h-3 bg-gray-300 rounded animate-pulse w-16"></div>
                </div>
              ))}
            </div>
          </div>
        </>
      ) : (
        <>
          {/* Actual Calendar Content */}
          <div className="flex items-center justify-between mb-6">
            <button
              onClick={() => navigateMonth(-1)}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              aria-label="Previous month"
            >
              <svg
                className="w-6 h-6 text-gray-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>

            <h2 className="text-lg font-semibold text-gray-800">
              {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()} -{" "}
              {monthNames[(currentDate.getMonth() + 2) % 12]}{" "}
              {currentDate.getMonth() + 2 > 11
                ? currentDate.getFullYear() + 1
                : currentDate.getFullYear()}
            </h2>

            <button
              onClick={() => navigateMonth(1)}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              aria-label="Next month"
            >
              <svg
                className="w-6 h-6 text-gray-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>

          {/* Three months display */}
          <div className="flex gap-4 mb-6">
            {threeMonths.map((monthData, index) =>
              renderMonth(monthData, index),
            )}
          </div>

          <div className="mt-6 pt-4 border-t border-gray-200">
            <div className="grid grid-cols-2 md:grid-cols-6 gap-2 text-xs">
              <div className="flex items-center">
                <div className="w-4 h-4 bg-green-100 border-2 border-green-300 rounded mr-2"></div>
                <span>Available</span>
              </div>
              <div className="flex items-center">
                <div className="w-4 h-4 bg-indigo-100 border-2 border-indigo-400 rounded mr-2"></div>
                <span>EDP Only</span>
              </div>
              <div className="flex items-center">
                <div className="w-4 h-4 bg-yellow-100 border-2 border-yellow-300 rounded mr-2"></div>
                <span>Pending</span>
              </div>
              <div className="flex items-center">
                <div className="w-4 h-4 bg-red-100 border-2 border-red-300 rounded mr-2"></div>
                <span>Booked</span>
              </div>
              <div className="flex items-center">
                <div className="w-4 h-4 bg-blue-500 rounded mr-2"></div>
                <span>Selected</span>
              </div>
              <div className="flex items-center">
                <div className="w-4 h-4 bg-orange-50 border border-orange-200 rounded mr-2"></div>
                <span>Sunday (OFF)</span>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Calendar;
